// 直播配置
import { getLiveRoomOrgConfig } from '@/api/liveRoom/index.js'
import { getTenantDefaultConfigApi } from '@/api/liveRoom/setting.js'

const state = {
  attendClassTime: '', // 到课时间定义，单位分钟
  finishClassTime: '', // 完课时间定义，单位分钟
  tenantDefaultConfig: {}, // 机构级默认配置（edata-live/tenant/defaultConfig/get）
  inputIfCmdFlag: false, // 是否命中指令输入
  portraitModeMax: true // 是否横屏大屏模式
}
const mutations = {
  set_state: (state, { key, data }) => {
    state[key] = data
  },
  SET_TENANT_DEFAULT_CONFIG: (state, payload = {}) => {
    const data = payload?.data ?? payload ?? {}
    state.tenantDefaultConfig = data
  },
  setPortraitModeMax(state, data) {
    state.portraitModeMax = data
  },
  setInputIfCmdFlag(state, data) {
    state.inputIfCmdFlag = data
  }
}
const actions = {
  // 设置是否横屏模式
  setPortraitModeMax({ commit }, data) {
    commit('setPortraitModeMax', data)
  },
  // 获取直播设置数据
  getLiveRoomOrgConfig({ commit }) {
    return getLiveRoomOrgConfig().then(res => {
      commit('set_state', {
        key: 'attendClassTime',
        data: res.data.attendClassTime || 0
      })
      commit('set_state', {
        key: 'finishClassTime',
        data: res.data.finishClassTime || 0
      })
      return res
    })
  },
  // 获取机构级直播间默认配置（tenant/defaultConfig/get）
  // 命中后同时拆解常用字段到 state 单字段，方便组件 mapState 直接用
  fetchTenantDefaultConfig({ commit }) {
    return getTenantDefaultConfigApi()
      .then(res => {
        if (res && res.success) {
          commit('SET_TENANT_DEFAULT_CONFIG', res.data || {})
        } else {
          commit('SET_TENANT_DEFAULT_CONFIG', {})
        }
        return res
      })
      .catch(err => {
        commit('SET_TENANT_DEFAULT_CONFIG', {})
        throw err
      })
  },
  // 设置是否命中指令输入
  setInputIfCmdFlag({ commit }, data) {
    commit('setInputIfCmdFlag', data)
  }
}
export default {
  namespaced: true,
  longTime: true,
  state,
  mutations,
  actions
}
